import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import env from '../../../environments';
import { resolveLegacyPrintShopPath } from './queues';

/**
 * `/print-shop` was the Ticket Queue. It now has no page of its own and sends
 * old links to the matching queue — Books by default (ADR-003). `replace`
 * keeps the redirect out of the history, so Back does not bounce.
 */
export default function PrintShopLegacyRedirect() {
  const { search } = useLocation();
  return (
    <Navigate to={resolveLegacyPrintShopPath(search, env.ENABLE_MOD)} replace />
  );
}
